/** @format */

import React, { lazy, Suspense } from "react";
import { Box } from "./MuiCompat";

const HeroShader = lazy(() => import("./HeroShader"));

const fontInter = `'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, sans-serif`;

const Hero: React.FC = () => {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        minHeight: "100vh",
        color: "var(--color-snow)",
        overflow: "hidden",
        fontFamily: fontInter,
        "@keyframes eonFadeUp": {
          from: { opacity: 0, transform: "translateY(14px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
        "@media (prefers-reduced-motion: reduce)": {
          "& [data-reveal]": {
            animation: "none !important",
            opacity: "1 !important",
            transform: "none !important",
          },
        },
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "130vw", sm: "110vw", md: "1300px" },
          height: { xs: "75vh", md: "820px" },
          maxWidth: "1300px",
          maxHeight: "820px",
          zIndex: 1,
          pointerEvents: "none",
          maskImage:
            "radial-gradient(ellipse 55% 50% at 50% 50%, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.85) 45%, rgba(0, 0, 0, 0) 90%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 55% 50% at 50% 50%, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.85) 45%, rgba(0, 0, 0, 0) 90%)",
          opacity: 0.95,
        }}
      >
        <Suspense fallback={null}>
          <HeroShader />
        </Suspense>
      </Box>

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          minHeight: "100vh",
          px: { xs: 3, sm: 5, md: 8 },
          py: { xs: 14, md: 16 },
          maxWidth: "var(--page-max-width)",
          mx: "auto",
          width: "100%",
        }}
      >
        <Box
          data-reveal
          component="h1"
          sx={{
            m: 0,
            fontFamily: fontInter,
            fontWeight: 600,
            fontSize: "clamp(2.6rem, 6.4vw, 5rem)",
            lineHeight: "var(--leading-display)",
            letterSpacing: "var(--tracking-display)",
            color: "var(--color-snow)",
            opacity: 0,
            animation:
              "eonFadeUp 0.7s cubic-bezier(0.23, 1, 0.32, 1) 0.05s forwards",
          }}
        >
          Reprogram your life
        </Box>

        <Box
          data-reveal
          sx={{
            mt: { xs: 3, md: 4 },
            maxWidth: "600px",
            fontFamily: fontInter,
            fontWeight: 500,
            fontSize: "clamp(1rem, 1.4vw, 1.25rem)",
            lineHeight: 1.45,
            letterSpacing: "var(--tracking-subheading)",
            color: "rgba(255, 255, 255, 0.86)",
            textShadow: "0 1px 12px rgba(4, 5, 6, 0.55)",
            opacity: 0,
            animation:
              "eonFadeUp 0.7s cubic-bezier(0.23, 1, 0.32, 1) 0.18s forwards",
          }}
        >
          Personal AI agents that work in the background, so your goals keep
          moving forward while you live your life.
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
